import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunckFailedHandler implements ErrorHandler {
  handleError(e: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(e.message)) {
      window.location.reload();
    }
  }
}
